import { injectable } from 'inversify';

import axios, { AxiosPromise } from 'axios';

import IocContainer from '../container/IocContainer';
import SERVICES     from '../services/services';

import CertificateValidation from '../interfaces/CertificateValidation';

@injectable()
export default class CertificateValidationProvider implements CertificateValidation {

  http;

  constructor () {
    this.http = axios.create({
      baseURL: process.env.API_URL,
      headers: {
        Accept: 'application/json',
      },
    });
  }
  /**
   * @returns {AxiosPromise<any>}
   */
  public async verifyCertificate(certId, lastName) {
    return await this.http.get('/verify-certificate?certid=' + certId + '&lastname=' + lastName);
  }
}
